/*
 * 路由组件的处理方法

 */
import iView from 'iview';

/**
 * 是否是需要校验的
 * @param  {String} name {路由名}
 * @return {boolean} {true代表是需要校验的路由}
 */
function needChecked(name) {
	const uncheckedRouters = [
		'login',
		'admin-login',
	];

	return uncheckedRouters.indexOf(name) === -1;
}

/**
 * 如果不是登录页面，则判断是否存在用户的token，不然就重新跳转会login页面
 * @param {Object} to {将要去到的路由对象to}
 * @return {boolean}
 */
function shouldLogOut(to) {
	return needChecked(to.name) && !sessionStorage.getItem('token');
}


/**
 * 是否是登录页面
 * @param  {String} name {需要判断的当前路由的name}
 * @return {Boolean} {true代表是登录页面}
 */
function isLoginPage(name) {
	return name === 'login' || name === 'admin-login';
}

// iview相关的控制对象
const iviewControl = {
	// 进度条开始
	loadingStart() {
		iView.LoadingBar.start();
	},
	// 进度条结束
	loadingEnd() {
		iView.LoadingBar.finish();
	},
	// 显示错误信息
	showErrorMessage(msg, duration = 3) {
		iView.Message.error({
			content: msg, //
			duration,
		});
	},
};

/**
 * 重定向的处理操作
 * @param  {Object} to   {将要前往的路由对象}
 * @param  {Object} from {已经离开的路由对象}
 * @param  {Function} next {路由继续往下执行的方法}
 * @return {undefined}
 */
function redirectHandle(to, from, next) {
	if (isLoginPage(from.name)) {
		iView.LoadingBar.finish();
	} else {
		const to_path = to.fullPath;

		let login_path_new = '';



		if (to_path.indexOf('/panx-home') === 0) {
			login_path_new = '/admin-login';
		} else {
			login_path_new = 'login';
		}


		next({
			path: login_path_new,
		});
	}
}

/**
 * 重定向流程
 * @param  {Object} to   {将要前往的路由对象}
 * @param  {Object} from {已经离开的路由对象}
 * @param  {Function} next {路由继续往下执行的方法}
 * @return {undefined}
 */
function redirectToLoginPage(to, from, next) {
	const err_msg = '没有登录权限！即将为您跳转登录页面';

	iviewControl.showErrorMessage(err_msg);

	setTimeout(redirectHandle(to, from, next), 3000);
}

// 路由处理方法
const handleRouter = {
	// 路由切换前的处理
	before(to, from, next) {
		// iview show loading
		iviewControl.loadingStart();


		if (shouldLogOut(to)) {
			return redirectToLoginPage(to, from, next);
		}

		return next();
	},
	// 路由切换后的处理
	after() {
		iviewControl.loadingEnd();
		window.scrollTo(0, 0);
	},
};

export default handleRouter;
